import React from 'react';
import {Form} from "./page/Form";

function App() {
  return (
      <Form/>
  )
}

export default App;
